import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Combina clases de Tailwind resolviendo los conflictos a favor de la ultima. */
export function cn(...clases: ClassValue[]): string {
  return twMerge(clsx(clases));
}
